import { render } from "./QuizResult.vue?vue&type=template&id=50e205ba"
import script from "./QuizResult.vue?vue&type=script&lang=js"
export * from "./QuizResult.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__